import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import illustration from '../../../../../images/survey/call-illustration.svg';
import { personalizedOnboarding } from '../../../../../services/survey.service';
import { Mixpanel } from '../../../../../utils/mixpanel';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';

const SurveyFinalScreen = ({ type, onClose }) => {
  const { userDetails } = useSelector((state) => state.user);
  const title = type === 'personalized' ? 'Prefer personalized onboarding?' : 'Want a longer 14-day trial?';
  const description =
    type === 'personalized' ? (
      <div>
        The platform is great, but having a real human to chat with is better.
        <br />
        <br />
        Yash and team have scaled influencer programs for 100’s of brands. We can help you decide the best strategy,
        answer any questions about the platform, and give you a real human concierge. <br />
        <br />
        If you want an extended 14-day trial, we'll set that up after you book so you have enough time to make a
        decision once we speak.
      </div>
    ) : (
      <div>
        The platform is great, but having a real human to chat with is better.
        <br />
        <br />
        Yash and team have scaled influencer programs for 100’s of brands. We can help you decide the best strategy,
        answer any questions about the platform, and put a face to the tech. <br />
        <br />
        At the end of the call, we'll leave you with a strategy tailor-made for your brand.
      </div>
    );

  const primaryButtonText = type === 'personalized' ? 'I want to speak' : 'Reserve & Extend Trial';
  const secondaryButtonText = type === 'personalized' ? 'I’ll explore myself' : "I'll be fine with 7 days";
  const navigate = useNavigate();

  const stateData = { strategySessionPerson: 'galy' };

  const handlePrimaryButtonClick = async () => {
    Mixpanel.identify(userDetails?._id);
    Mixpanel.people.set({ 'Strategy Session Requested': true });
    Mixpanel.track('onboarding_step_completed', {
      'Step Name': 'Final Step',
      'Step Number': 4,
      Responses: { personalisedOnboarding: true },
    });
    if (type === 'personalized') {
      await personalizedOnboarding({ personalisedOnboarding: true });
      navigate('/book-session?next=onboarding');
      onClose(false);
    } else {
      navigate('/book-session?next=onboarding');
      await personalizedOnboarding({ personalisedOnboarding: false });
      onClose(false);
    }
  };

  const handleSecondaryButtonClick = async () => {
    Mixpanel.people.set({ 'Strategy Session Requested': false });
    Mixpanel.track('onboarding_step_completed', {
      'Step Name': 'Final Step',
      'Step Number': 4,
      Responses: { personalisedOnboarding: false },
    });
    await personalizedOnboarding({ personalisedOnboarding: false });
    onClose();
  };

  return (
    <div className="survey-final-container">
      <div className="survey-final-content">
        <div className="survey-final-left">
          <div className="survey-final-text">
            <div className="title">{title}</div>
            <div className="description">{description}</div>
          </div>
          <div className="survey-final-bottom-container">
            <ButtonComponent onClick={handleSecondaryButtonClick} style={{ flex: 1 }} variant="secondary">
              {secondaryButtonText}
            </ButtonComponent>
            <ButtonComponent style={{ flex: 1 }} onClick={handlePrimaryButtonClick}>
              {primaryButtonText}
            </ButtonComponent>
          </div>
        </div>
        <div className="survey-final-illustration">
          <img src={illustration} alt="illustration" />
        </div>
      </div>
    </div>
  );
};

export default SurveyFinalScreen;
